import styled from "@emotion/styled";
import Link from "@mui/material/Link";
import StyledSummaryCardLogo from "styles/StyledComponents/StyledSummaryCardLogo.tsx";

export const AddressWrapper = styled.div(({ theme }) => ({
	display: "grid",
	gap: "1rem",
	gridTemplateColumns: "repeat(2, 1fr)",
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr"
	},
	div: {
		alignItems: "flex-start",
		margin: 0
	}
}));

export const CommentWrapper = styled.div({
	p: {
		margin: 0
	}
});

export const OrderDetailsSummaryContainer = styled.div(({ theme }) => ({
	margin: "1rem",
	backgroundColor: theme.project.colors.backgroundColors.main,
	boxShadow: `0 3px 1px -2px ${theme.palette.grey[400]}`,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const OrderDetailsBrandLogoContainer = styled.div({
	display: "flex",
	alignItems: "center",
	minHeight: 16
});

export const OrderDetailsBrandLogo = styled(StyledSummaryCardLogo)({
	height: "14px"
});

export const LegalNoticeContainer = styled.div(({ theme }) => ({
	color: theme.project.colors.fontColors.secondary,
	backgroundColor: theme.palette.grey[100],
	padding: "8px",
	"span:nth-of-type(1)": {
		...theme.project.typography.subtitle.subtitle2,
		marginRight: 2
	},
	"span:nth-of-type(2)": {
		...theme.project.typography.body.body2
	}
}));

export const StyledLink = styled(Link)(({ theme }) => ({
	...theme.project.typography.body.body2,
	textDecorationColor: theme.project.colors.fontColors.main,
	color: theme.project.colors.fontColors.main
}));

interface OrderDetailsColumnsContainerProps {
	isMerchOrder?: boolean;
}

export const OrderDetailsColumnsContainer = styled.div<OrderDetailsColumnsContainerProps>(
	({ theme, isMerchOrder }) => ({
		display: "grid",
		gridTemplateColumns: isMerchOrder ? "repeat(2, minmax(0, 1fr))" : "repeat(2, 2fr) repeat(3, 1fr)",
		gap: 16,
		div: {
			"> :first-of-type": {
				...theme.project.typography.subtitle.subtitle2,
				color: theme.project.colors.fontColors.main,
				alignItems: "center"
			},
			"> :last-of-type": {
				...theme.project.typography.body.body2,
				color: theme.project.colors.fontColors.secondary,
				alignItems: "center"
			}
		},
		[theme.breakpoints.down("sm")]: {
			gridTemplateColumns: "1fr",
			div: {
				display: "block"
			}
		}
	})
);
